import { useState } from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

// All uploaded gallery images
const galleryImages = [
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/5p6h0udy_Screenshot_20260223_041650_Instagram.jpg', alt: 'Laksa - Malaysian curry noodle soup', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/uk598u9x_Screenshot_20260223_041656_Instagram.jpg', alt: 'Nasi Lemak with French omelette', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/8zixv1ip_Screenshot_20260223_041731_Instagram.jpg', alt: 'Gelato with toppings', category: 'dessert' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/s1rrg7im_Screenshot_20260223_041920_Instagram.jpg', alt: 'Nasi Lemak - Malaysian coconut rice', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/100lf3aj_Screenshot_20260223_041955_Instagram.jpg', alt: 'Signature iced drink', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/fly9qe4n_Screenshot_20260223_041427_Instagram.jpg', alt: 'Grilled sandwich with flowers', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/8ae7apwz_Screenshot_20260223_041434_Instagram.jpg', alt: 'Apple turnover with ice cream', category: 'dessert' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/v8mcbqzw_Screenshot_20260223_041514_Instagram.jpg', alt: 'Grilled panini sandwich', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/h62s8bau_Screenshot_20260223_041544_Instagram.jpg', alt: 'Golden turmeric latte', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/5vt70320_Screenshot_20260223_041602_Instagram.jpg', alt: 'Fresh salad with fried chicken', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/z4n4v25l_Screenshot_20260223_041336_Instagram.jpg', alt: 'Iced coffee with branding', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/ikeegoxe_Screenshot_20260223_041359_Instagram.jpg', alt: 'Matcha lattes', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/iwup6wtu_Screenshot_20260223_041408_Instagram.jpg', alt: 'Golden latte with art', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/2dujnef2_Screenshot_20260223_041416_Instagram.jpg', alt: 'Latte with chocolate shavings', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/csr52hkc_Screenshot_20260223_041422_Instagram.jpg', alt: 'Chocolate raspberry tarts', category: 'dessert' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/7isfq9g8_Screenshot_20260223_041210_Instagram.jpg', alt: 'Iced matcha drinks lineup', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/qjmyijwu_Screenshot_20260223_041216_Instagram.jpg', alt: 'Cinnamon latte art', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/4fvb3f54_Screenshot_20260223_041245_Instagram.jpg', alt: 'Latte art rosetta', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/nh7ir0qc_Screenshot_20260223_041250_Instagram.jpg', alt: 'Coffee on silver tray', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/y44ual7m_Screenshot_20260223_041308_Instagram.jpg', alt: 'Affogato - gelato with espresso', category: 'dessert' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/fz1mjpre_Screenshot_20260223_041101_Instagram.jpg', alt: 'Espresso pour', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/3fiig4ir_Screenshot_20260223_041106_Instagram.jpg', alt: 'Murtabak with salad', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/5hkftk94_Screenshot_20260223_041111_Instagram.jpg', alt: 'Fresh croissants', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/ldpk43rk_Screenshot_20260223_041132_Instagram.jpg', alt: 'Pistachio swirl pastries', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/w3qid24g_Screenshot_20260223_041150_Instagram.jpg', alt: 'Almond croissants', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/2e8asfl4_Screenshot_20260223_041020_Instagram.jpg', alt: 'Cinnamon swirls', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/e5xpanv1_Screenshot_20260223_041025_Instagram.jpg', alt: 'The Crookie', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/0ycx2qz8_Screenshot_20260223_041031_Instagram.jpg', alt: 'Weekend pastries display', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/28m89izo_Screenshot_20260223_041036_Instagram.jpg', alt: 'Apricot croissants', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/kttyyjww_Screenshot_20260223_041052_Instagram.jpg', alt: 'Pain suisse chocolate', category: 'pastry' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/aensszos_Screenshot_20260223_040749_Instagram.jpg', alt: 'Eclairs trio', category: 'dessert' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/hpuctya1_Screenshot_20260223_040754_Instagram.jpg', alt: 'Hot chocolate marshmallows', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/s7igosza_Screenshot_20260223_040806_Instagram.jpg', alt: 'Pistachio hot chocolate', category: 'drinks' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/cmj5zyuo_Screenshot_20260223_040841_Instagram.jpg', alt: 'Sambal Cilbir', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/pjq99b7w_Screenshot_20260223_040936_Instagram.jpg', alt: 'Hello Avocado with poached eggs', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/7vn2etv0_Screenshot_20260223_040744_Instagram.jpg', alt: 'Nasi Lemak on banana leaf', category: 'food' },
  { src: 'https://customer-assets.emergentagent.com/job_613d9870-32bb-4e09-a93a-6fd29666cc9c/artifacts/0t0svnlk_Screenshot_20260223_025737.jpg', alt: 'Branded takeaway cup', category: 'drinks' },
];

const categories = [
  { id: 'all', label: 'All' },
  { id: 'food', label: 'Food' },
  { id: 'drinks', label: 'Drinks' },
  { id: 'pastry', label: 'Pastries' },
  { id: 'dessert', label: 'Desserts' },
];

export default function GalleryPage() {
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <div className="min-h-screen pt-24" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#FAFAF5]">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-xs tracking-[0.2em] text-neutral-500 uppercase mb-4">Our Creations</p>
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-black mb-6">
              Gallery
            </h1>
            <p className="text-neutral-600 leading-relaxed text-lg mb-8">
              A visual journey through our organic coffee, Malaysian-inspired fusion dishes, 
              and freshly baked pastries. Every item crafted with love.
            </p>
            
            {/* Instagram Link */}
            <a
              href="https://www.instagram.com/honeyimhome.coffee/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
              data-testid="instagram-link"
            >
              <Instagram size={18} />
              Follow @honeyimhome.coffee
              <ExternalLink size={14} />
            </a>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="bg-white border-b border-neutral-200 sticky top-20 z-10">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="flex justify-center gap-2 py-4 overflow-x-auto">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setFilter(cat.id)}
                className={`px-6 py-2 text-sm font-medium transition-all whitespace-nowrap ${
                  filter === cat.id
                    ? 'bg-black text-white'
                    : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
                }`}
                data-testid={`filter-${cat.id}`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                onClick={() => setSelectedImage(image)}
                className="aspect-square relative overflow-hidden bg-neutral-100 cursor-pointer group"
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                {/* Hover overlay with caption */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-end">
                  <p className="text-white text-sm p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {image.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          {/* Image count */}
          <p className="text-center text-neutral-400 text-sm mt-8">
            Showing {filteredImages.length} of {galleryImages.length} images
          </p>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-4xl hover:text-neutral-300 transition-colors"
            aria-label="Close"
          >
            &times;
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="absolute bottom-8 left-0 right-0 text-center text-white text-lg">
            {selectedImage.alt}
          </p>
        </div>
      )}

      {/* Call to Action */}
      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-semibold mb-4">
            Visit Us Today
          </h2>
          <p className="text-neutral-400 mb-8">
            Experience these delicious creations in person at our cosy café in Woodford Green.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/menu"
              className="bg-white text-black px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-neutral-200 transition-colors"
            >
              View Menu
            </a>
            <a
              href="/contact"
              className="border border-white text-white px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-white hover:text-black transition-colors"
            >
              Reserve a Table
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
